<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <div v-if="pagination" class="swiper-pagination"></div>
  </div>
</template>
<script>
/**
   * @param options [Object] swiper4参数配置详见http://www.swiper.com.cn/
   * @param loop [Boolean] 是否循环
   * @param autoplay [Boolean] 是否自动轮播
   * @param pagination [Boolean] 是否显示分页
   * @describe options配置权限最高配置后会覆盖外部设置的属性，需与swiper-slide组件配合使用
   *
   * @example
   *
    <swiper loop pagination v-fill="{fill: !bannerList.length, height: '2.25rem'}">
      <swiper-slide v-for="(item, index) in bannerList" :key="index"><img :src="item" alt=""></swiper-slide>
    </swiper>
   */
import Swiper from 'swiper';

export default {
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    loop: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Number,
      default: 5000
    },
    pagination: {
      type: Boolean,
      default: false
    },
    direction:{
      type:String,
      default:'horizontal'
    },
    slidesPerView:{
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      inited: false,
      swiper: {},
    };
  },
  activated() {
    this.update();
  },
  updated() {
    this.update();
  },
  beforeDestroy() {
    this.$nextTick(function () {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy();
        delete this.swiper;
      }
    });
  },
  methods: {
    initSwiper: function () {
      if (this.inited) {
        return;
      }
      this.swiper = new Swiper(this.$el, Object.assign({
        speed: 300, // 切换速度
        paginationClickable: true,
        initialSlide: 0, // 初始索引
        autoHeight: true, // 高度随内容变化
        direction: this.direction, // 滑动方向
        loop: this.loop, // 循环
        autoplay: this.autoplay, // 自动切换的时间间隔（单位ms），不设定该参数slide不会自动切换。
        pagination: this.pagination ? '.swiper-pagination' : null, // 是否需要分页
        // 显示多个设置
        slidesPerView: this.slidesPerView, // 多个设定数量也可以auto
        slidesPerGroup: 1, // 多个时滑动多少个为一组
        spaceBetween: 0, // 多个之间的距离
        slidesPerColumn: 1, // 显示行数
        slidesPerColumnFill: 'row', // 显示多行排列方式
      }, this.options));
      this.inited = true;
    },
    update() {
      if (this.swiper) {
        if (this.swiper.update) this.swiper.update();
        /*if (this.swiper.navigation) this.swiper.navigation.update();
        if (this.swiper.pagination) this.swiper.pagination.render();
        if (this.swiper.pagination) this.swiper.pagination.update();*/
      }
    },
  },
};

</script>
<style lang="scss">
  .swiper-pagination-bullet {
    width: 70px;
    height: 15px;
    display: inline-block;
    border-radius: 0;
    background: rgba(0,0,0,.4);
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: #d93d41;

  }


</style>



// WEBPACK FOOTER //
// src/components/swiper.vue